import { AI_PROCESS_SCOPE_TYPE } from 'app/pages/system/aiProcesses/shared/aiProcess.constants';
import _ from 'lodash';

import { AiProcessExecutionLiveStatuses, AiProcessOwnerKind } from 'constants/aiProcessRuns';

const SCOPE_TYPE_BY_OWNER_KIND = {
  [AiProcessOwnerKind.LOAN_APPLICATION]: AI_PROCESS_SCOPE_TYPE.LOAN_APPLICATION,
  [AiProcessOwnerKind.SUB_COMPANY]: AI_PROCESS_SCOPE_TYPE.SUB_COMPANY,
  [AiProcessOwnerKind.RATE_SHEET_UPLOAD]: AI_PROCESS_SCOPE_TYPE.RATE_SHEET_UPLOAD,
};

export const filterStartableProcesses = (processes, ownerKind) => {
  const scopeType = SCOPE_TYPE_BY_OWNER_KIND[ownerKind];

  if (!scopeType) {
    return [];
  }

  return (processes ?? []).filter(process => process?.scopeType === scopeType);
};

const matchesSearchTerm = (process, searchTerm) => {
  if (_.isNil(searchTerm) || searchTerm.trim() === '') {
    return true;
  }

  const normalized = searchTerm.trim().toLowerCase();
  const name = (process?.name ?? '').toLowerCase();
  const description = (process?.description ?? '').toLowerCase();

  return name.includes(normalized) || description.includes(normalized);
};

export const filterProcessesBySearch = (processes, searchTerm) =>
  (processes ?? []).filter(process => matchesSearchTerm(process, searchTerm));

export const findLiveRunForProcess = (liveRuns, processId) =>
  (liveRuns ?? []).find(
    run => run?.aiProcessId === processId && AiProcessExecutionLiveStatuses.has(run?.status),
  ) ?? null;

export const findLastRunForProcess = (runs, processId) => {
  const matching = (runs ?? []).filter(run => run?.aiProcessId === processId);

  if (matching.length === 0) {
    return null;
  }

  return _.maxBy(matching, run => new Date(run?.startedAt ?? 0).getTime()) ?? null;
};
